/**
=========================================================
* Trust Cargo - table head
=========================================================
*/

// Soft UI Dashboard React base styles
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

// Soft UI Dashboard React helper functions
import pxToRem from "assets/theme/functions/pxToRem";
import rgba from "assets/theme/functions/rgba";

const { borderRadius, borderWidth } = borders;
const { dark, primary, grey } = colors;
const { size, fontWeightBold } = typography;

const tableHead = {
  styleOverrides: {
    root: {
      /**
       * The stock theme set `display: block` here, which takes the header out
       * of the table layout so its columns stop lining up with the body. The
       * Soft UI table renders its own <thead>, so nothing depended on it -
       * every plain MUI table in the app was just paying the cost.
       */
      display: "table-header-group",
      backgroundColor: grey[100],
      borderRadius: `${borderRadius.lg} ${borderRadius.lg} 0 0`,

      "& th": {
        // small, spaced and navy: reads as a label, not as data
        padding: `${pxToRem(14)} ${pxToRem(20)}`,
        fontSize: size.xxs,
        fontWeight: fontWeightBold,
        textTransform: "uppercase",
        letterSpacing: "0.09em",
        color: rgba(dark.main, 0.62),
        whiteSpace: "nowrap",
        backgroundColor: "transparent",
        // one gold hairline under the whole header separates labels from data
        borderBottom: `${borderWidth[2]} solid ${rgba(primary.main, 0.35)}`,
      },
    },
  },
};

export default tableHead;
